import React from "react";

import PrismicImgix from "@sendmagic/prismic-nextjs/src/components/Imgix";
import PrismicLinkTag from "@sendmagic/prismic-nextjs/src/components/LinkTag";

import { textResolver } from "@sendmagic/prismic-nextjs/src/constants/text-resolver";

const BorderedTwoImageRow = ({ doc }) => {
  const { heading, description, dark_theme, internal_link_id } = doc?.primary || {};

  return (
    <div className={`pt-5 px-md-5 px-1 prismic-slice  ${dark_theme && "dark-theme"}`}>
      {internal_link_id && (
        <span id={internal_link_id} className="scroll-point position-relative d-block" />
      )}
      <div className="container">
        <div className="fs-3 mobile-fs-24 text-center font-weight-bold mb-4 mb-lg-5 mb-2xl-5">
          {textResolver(heading)}
        </div>

        <div>{textResolver(description)}</div>

        <div className="row">
          {doc.items.map(
            (
              {
                image,
                heading: textHeading,
                subheading,
                description: textDescription,
                link_text,
                link,
              },
              index
            ) => (
              <div className="col-md-6 mb-3 mb-md-5 mb-2xl-5" key={index}>
                <div className="d-flex flex-column h-100 br-1 p-3 p-md-4 p-lg-5 p-2xl-5 border">
                  <div className="mb-4 mb-lg-5 mb-2xl-5">
                    <PrismicImgix
                      className="img-fluid d-block mx-auto"
                      src={image?.url}
                      alt={image?.alt || "user"}
                      desktop="450px"
                      mobile="100%"
                      tablet="260px"
                      largeDisplay="900px"
                    />
                  </div>

                  <div className="fs-3 mobile-fs-24 text-center font-weight-bold mb-4 mb-2xl-4">
                    {textResolver(textHeading)}
                  </div>
                  <div className="fs-1-7 mobile-fs-16 lh-1-3 mb-3 mb-lg-4 mb-2xl-4">
                    {textResolver(subheading)}
                  </div>
                  <div className="ol-yellow-marker fs-1-7 mobile-fs-16 lh-1-3 mb-4 mb-lg-4 mb-2xl-4">
                    {textResolver(textDescription)}
                  </div>

                  <div className="mt-auto text-center">
                    {link?.url && (
                      <PrismicLinkTag
                        urlText={link_text}
                        url={link?.url}
                        target={link?.target}
                        className="d-inline-block"
                      />
                    )}
                  </div>
                </div>
              </div>
            )
          )}
        </div>
      </div>
    </div>
  );
};

export default BorderedTwoImageRow;
